import { StyleSheet } from 'react-native';
import {
  CELEBRATION_COLORS,
  LEVEL_NUMBER_SIZE,
  LEVEL_STAGE_SIZE,
} from '../../constants/celebrations.constants';

const RAYS_SIZE = 300;
const GLOW_SIZE = 158;
const SHOCK_SIZE = 128;

// Colors are design-system constants (celebration design file), not theme-derived
export const getLevelUpCelebrationStyles = () =>
  StyleSheet.create({
    scrim: {
      flex: 1,
      backgroundColor: CELEBRATION_COLORS.SCRIM,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 24,
      paddingVertical: 32,
    },
    stage: {
      width: LEVEL_STAGE_SIZE,
      height: LEVEL_STAGE_SIZE,
      alignItems: 'center',
      justifyContent: 'center',
    },
    raysWrap: {
      position: 'absolute',
      width: RAYS_SIZE,
      height: RAYS_SIZE,
      left: LEVEL_STAGE_SIZE / 2 - RAYS_SIZE / 2,
      top: LEVEL_STAGE_SIZE / 2 - RAYS_SIZE / 2,
    },
    glowWrap: {
      position: 'absolute',
      width: GLOW_SIZE,
      height: GLOW_SIZE,
      left: LEVEL_STAGE_SIZE / 2 - GLOW_SIZE / 2,
      top: LEVEL_STAGE_SIZE / 2 - GLOW_SIZE / 2,
    },
    shockRing: {
      position: 'absolute',
      width: SHOCK_SIZE,
      height: SHOCK_SIZE,
      borderRadius: SHOCK_SIZE / 2,
      borderWidth: 3,
      borderColor: 'rgba(252, 211, 77, 0.7)',
    },
    numberBlock: {
      alignItems: 'center',
    },
    numberText: {
      fontSize: LEVEL_NUMBER_SIZE,
      lineHeight: LEVEL_NUMBER_SIZE * 0.98,
      fontWeight: '800',
      letterSpacing: -2,
      color: CELEBRATION_COLORS.GOLD,
      fontVariant: ['tabular-nums'],
      // Static approximation of the design's animated glow (zpNumGlow)
      textShadowColor: 'rgba(252, 211, 77, 0.55)',
      textShadowOffset: { width: 0, height: 0 },
      textShadowRadius: 24,
    },
    numberLabel: {
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 3.4,
      color: CELEBRATION_COLORS.GOLD,
      marginTop: 2,
    },
    textBlock: {
      alignItems: 'center',
      marginTop: 16,
    },
    eyebrow: {
      fontSize: 13,
      fontWeight: '700',
      letterSpacing: 2.8,
      color: CELEBRATION_COLORS.MINT,
    },
    heading: {
      fontSize: 34,
      fontWeight: '800',
      letterSpacing: -0.3,
      color: CELEBRATION_COLORS.TEXT,
      marginTop: 4,
      textAlign: 'center',
    },
    chip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      marginTop: 10,
      backgroundColor: CELEBRATION_COLORS.SURFACE,
      borderRadius: 999,
      paddingVertical: 6,
      paddingHorizontal: 14,
    },
    chipText: {
      fontSize: 13,
      fontWeight: '600',
      color: '#D1D5DB',
    },
    xpBlock: {
      width: '100%',
      maxWidth: 280,
      marginTop: 22,
    },
    barTrack: {
      height: 8,
      backgroundColor: CELEBRATION_COLORS.TRACK,
      borderRadius: 999,
      overflow: 'hidden',
    },
    barFill: {
      height: '100%',
      borderRadius: 999,
    },
    barLabels: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 7,
    },
    barLabelText: {
      fontSize: 12,
      color: CELEBRATION_COLORS.MUTED,
      fontVariant: ['tabular-nums'],
    },
    continueBtn: {
      width: '100%',
      maxWidth: 280,
      minHeight: 48,
      marginTop: 24,
      backgroundColor: CELEBRATION_COLORS.PURPLE,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      shadowColor: CELEBRATION_COLORS.PURPLE,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.3,
      shadowRadius: 4,
      elevation: 4,
    },
    continueText: {
      fontSize: 16,
      fontWeight: '700',
      color: CELEBRATION_COLORS.INK,
    },
    btnPressed: {
      transform: [{ scale: 0.97 }],
    },
  });
